import React, { useEffect, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";

const API_URL = "https://server.account.majestyfx.com/admin_fetch_master_comission_pending.php"; 
const statusOptions = ["approved", "pending", "rejected"];

export default function ProfitCommissionWithdrawalHistory() {
  const [search, setSearch] = useState("");
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("pending");

  const fetchWithdrawals = async (status) => {
    try {
      setLoading(true);
      setError("");
      const res = await axios.post(
        API_URL,
        { status },
        { headers: { "Content-Type": "application/json", Accept: "application/json" } }
      );

     if (res.data?.success === true) {
  setWithdrawals(Array.isArray(res.data.requests) ? res.data.requests : []);
} else {
  setError("Failed to fetch commission withdrawal history");
  setWithdrawals([]);
}
    } catch (e) {
      setError(e?.response?.data?.error || e?.message || "Failed to connect to server");
      setWithdrawals([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWithdrawals(selectedStatus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStatus]);

  const filteredWithdrawals = withdrawals.filter((w) => {
    const q = search.toLowerCase();
    return (
      String(w.request_id || "").toLowerCase().includes(q) ||
      String(w.email || "").toLowerCase().includes(q) ||
      String(w.trade_id || "").toLowerCase().includes(q) ||
      String(w.status || "").toLowerCase().includes(q)
    );
  });

  const exportToExcel = () => {
    if (filteredWithdrawals.length === 0) {
      alert("No data to export");
      return;
    }

    const exportData = filteredWithdrawals.map((w, idx) => ({
      "#": idx + 1,
      "Request ID": w.request_id,
      "Date & Time": w.created_at,
      "Email": w.email,
      "Master Trade ID": w.master_trade_id || "-",
      "Slave Trade ID": w.trade_id || "-",
      "Commission Amount": w.amount,
      "Status": w.status,
      "Admin Comment": w.admin_comment || "-",
      "Source": w.source || "-",
      "Wallet Address": w.wallet_address || "-"
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Commission Withdrawal History");
    XLSX.writeFile(
      wb,
      `Profit_Commission_Withdrawal_${selectedStatus}_${new Date().toISOString().split("T")[0]}.xlsx`
    );
  };

  const StatusBadge = ({ status }) => {
    const key = String(status).toLowerCase();
    const label =
      key === "approved" ? "Approved" :
      key === "pending" ? "Pending" :
      key === "rejected" ? "Rejected" : String(status);

    return <span className={`status-badge status-${key}`}>{label}</span>;
  };

  return (
    <div className="main-content">
      <div className="page-header">
        <div>
          <h2>Profit Commission Withdrawal History</h2>
          <p className="subtitle">View and filter profit commission withdrawal requests</p>
        </div>

        <div className="header-actions">
          <div className="status-toggle">
            {statusOptions.map((opt) => (
              <button
                key={opt}
                className={`status-option ${opt} ${selectedStatus === opt ? "active" : ""}`}
                onClick={() => setSelectedStatus(opt)}
                disabled={loading}
              >
                {opt === "approved" ? "Approved" : opt === "pending" ? "Pending" : "Rejected"}
              </button>
            ))}
          </div>

          <button className="btn blue" onClick={() => fetchWithdrawals(selectedStatus)} disabled={loading}>
            {loading ? "Refreshing..." : "Refresh"}
          </button>

          <button className="btn green" onClick={exportToExcel} disabled={loading || withdrawals.length === 0}>
            Export to Excel
          </button>
        </div>
      </div>

      <div className="card">
        {/* Search */}
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
          <input
            type="text"
            placeholder="Search by email, trade id, request id..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              padding: "8px 12px",
              borderRadius: "6px",
              border: "1px solid #ddd",
              width: "280px",
              fontSize: "14px",
            }}
          />
        </div>

        <div className="table-container">
          <div className="table-scroll">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Request ID</th>
                  <th>Date & Time</th>
                  <th>Email</th>
                  <th>Master Trade ID</th>
                  <th>Slave Trade ID</th>
                  <th>Commission Amount</th>
                  <th>Status</th>
                  <th>Admin Comment</th>
                  <th>Source</th>
                  <th>Wallet Address</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="11" style={{ textAlign: "center" }}>Loading...</td>
                  </tr>
                ) : error ? (
                  <tr>
                    <td colSpan="11" style={{ color: "crimson", textAlign: "center" }}>{error}</td>
                  </tr>
                ) : filteredWithdrawals.length === 0 ? (
                  <tr>
                    <td colSpan="11" style={{ textAlign: "center" }}>No records found</td>
                  </tr>
                ) : (
                  filteredWithdrawals.map((w, idx) => (
                   <tr key={`${w.id}-${idx}`}>
  <td>{idx + 1}</td>
  <td>{w.id}</td>
  <td>{w.created_at}</td>
  <td>{w.email}</td>
  <td>{w.mastertrade}</td>
  <td>-</td> {/* Slave Trade ID nahi hai backend me */}
  <td>${w.amount}</td>
  <td><StatusBadge status={w.status} /></td>
  <td>-</td> {/* admin_comment nahi hai */}
  <td>-</td> {/* source nahi hai */}
  <td>-</td> {/* wallet_address nahi hai */}
</tr>
                  ))
                )}
              </tbody>

            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
